export enum TicketType {
  /** Заявка по открытию ПВЗ */
  openingOrder = 62,
  /** Планировка помещения */
  roomLayout = 72,
}

export enum TicketReason {
  eLock = 111,
  signboard = 112,
}

export type CreateTicketRequest = {
  ticketType: number
  description: string
  orderId: number
  files: TicketFiles
  ticketReason?: number
}

export type TicketFiles = {
  document_urls: string[]
  image_urls: string[]
  video_urls: string[]
}

export type TicketFileUploadDTO = {
  chunkNum: number
  status: string
  uploadedSize: number
  url: string
  uuid: string
}

export enum TicketPhotoType {
  /** Фасад здания днем */
  generalPhoto = 'generalPhoto',
  /** Документ БТИ */
  btiDocument = 'btiDocument',
}

export type TicketDTO = {
  id: number
  userId: number
  createDate: string
  finishDate: string
  description: string
  imageUrls: string[]
  videoUrls: string[]
  documentUrls: string[]
  ticketTypeId: number
  ticketTypeName: string
  ticketStateId: number
  supportLogs: TicketSupportLogsDTO[]
  ticketHistory: TicketHistoryDTO[]
  ticketGrade: number
  gradeComment: string
  openAfterAnswer: number
  isRead: boolean
  managerId: number
  updateDate: string
  orderId: number
  autoClose: number
}

export type TicketSupportLogsDTO = {
  id: number
  ticketId: number
  message: string
  userId: number
  isSend: boolean
  createDate: string
  imageUrls: string[] | null
  videoUrls: string[] | null
  documentUrls: string[] | null
  fio: string
  isManager: boolean
}

export type TicketHistoryDTO = {
  userId: number
  createDate: string
  fio: string
  state: number
  stateName: string
  ticketId: number
}

export type GetTicketListRequest = {
  page: number
  pageSize: number
  search?: string
  ticketStateId?: number
  ticketTypeIds?: number[]
  sortByCreateDate?: 'asc' | 'desc'
}

export type CreateSupportLogRequest = {
  ticketId: number
  message: string
  files?: TicketFiles
}

export enum TicketStatus {
  open = 1,
  inProgress = 2,
  closed = 3,
}

export type RateTicketRequest = {
  ticketId: number
  grade: number
  message: string
}
